var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div"},[_c('filters',{scopedSlots:_vm._u([{key:"statistics",fn:function(){return [_c('statistics',{scopedSlots:_vm._u([{key:"total",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.filesResponse.total))])]},proxy:true}])})]},proxy:true}])}),_c('files-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }